import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 5;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'custom-overview',
      title: `Custom Reports <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Build your own reports with flexible visualization. Choose accounts and funds, pick a time period, and view results as charts or data grids.',
      attachTo: { element: '[data-tour="custom-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'custom-modes',
      title: `Report Modes <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Three modes: <strong>Summary</strong> shows totals for a single period. <strong>Comparison</strong> puts this year side-by-side with last year. <strong>Trend</strong> shows how values change over time with line or bar charts.',
      attachTo: { element: '[data-tour="custom-mode-toggle"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'custom-filters',
      title: `Filters <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Select which accounts and funds to include. Filters carry over when you switch between modes, so you can quickly compare the same data in different views.',
      attachTo: { element: '[data-tour="custom-filters"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'custom-views',
      title: `Chart & Grid Views <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Toggle between chart and grid views. Charts give you a visual overview, while the grid shows exact numbers with sortable columns.',
      attachTo: { element: '[data-tour="custom-chart"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'custom-trend',
      title: `Trend Granularity <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'In Trend mode, choose your granularity — monthly, weekly, or quarterly. This controls how data points are grouped on the chart and in the grid.',
      attachTo: { element: '[data-tour="custom-mode-toggle"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'customReports',
  pathPattern: '/reports/custom-reports',
  getSteps,
  label: 'Custom Reports Tour',
});
